import * as superagent from 'superagent';

interface IUserClaimsRequestData {
  type: string;
  message: string;
  offerInfo: {
    price: {
      currency?: string;
      price?: number;
    },
    offerId?: string;
    address?: string;
  }
  contacts: {
    email: string;
    firstName?: string;
    phoneNumber?: string;
  },
  contactTime: {
    fromTime?: string;
    toTime?: string;
  },
  captcha: string;
}

export function sendUsersClaims(data: IUserClaimsRequestData): Promise<any> {
  return new Promise((resolve, reject) => {
    superagent
      .post('/cian-api/messages/v1/message/')
      .send(data)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) {
          reject(err);
          return;
        }

        if (res.body && res.body.status && res.body.status.toLowerCase() === 'ok') {
          resolve();
          return;
        }

        reject(new Error(`Unexpected Network Error: ${res.status}`));
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/user_claims.ts